// import axios from 'axios';
import { apiPost } from './index'

export function login(data) {
	return apiPost("/api/auth/login", data);
}

export function logout() {
	return apiPost("/api/auth/logout");
}

